import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "#components/molecules/Modal/Modal";
import { DurationField } from "#modules/onboardingV2/view/processStepConfiguration/DurationField";

type DurationModalProps = {
  opened: boolean;
  title: string;
  value: string | null;
  onClose: () => void;
  onSave: (value: string | null) => void;
};

export const DurationModal = ({ opened, title, value, onClose, onSave }: DurationModalProps) => {
  const { t } = useTranslation();
  const [stagedValue, setStagedValue] = useState(value);

  useEffect(() => {
    if (opened) {
      setStagedValue(value);
    }
  }, [opened, value]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      subtitle={t("onboardingV2.processStepConfiguration.durationModal.subtitle")}
      closeText={t("common.cancel")}
      primaryText={t("onboardingV2.processStepConfiguration.durationModal.save")}
      onPrimary={() => onSave(stagedValue)}
    >
      <DurationField value={stagedValue} onChange={setStagedValue} />
    </Modal>
  );
};
